import React, { useRef } from 'react';
import uploadIcon from '../../assets/upload-icon.png';
import { toast } from 'react-toastify';

const StepProfilePhoto = ({ data, onChange, onNext, loading = false, error }) => {
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange('profilePhoto', file);
    }
  };

  const handleNextClick = () => {
    if (!data.profilePhoto && !data.profilePhotoUrl) {
      toast.error("Profile photo is required.");
      return;
    }
    onNext(data, () => { });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 32, marginBottom: 8 }}>
        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M64.125 23.625H62.775C61.425 23.625 60.4125 22.95 59.7375 21.6L55.6875 13.8375C54.675 11.475 52.3125 10.125 49.6125 10.125H31.05C28.6875 10.125 26.325 11.475 24.975 13.8375L21.2625 21.6C20.5875 22.95 19.575 23.625 18.225 23.625H16.875C9.45 23.625 3.375 29.7 3.375 37.125V57.375C3.375 64.8 9.45 70.875 16.875 70.875H64.125C71.55 70.875 77.625 64.8 77.625 57.375V37.125C77.625 29.7 71.55 23.625 64.125 23.625ZM40.5 57.375C33.075 57.375 27 51.3 27 43.875C27 36.45 33.075 30.375 40.5 30.375C47.925 30.375 54 36.45 54 43.875C54 51.3 47.925 57.375 40.5 57.375Z" fill="#27B99A" />
        </svg>
      </div>
      <h2 style={{ margin: 0 }}>Profile Photo</h2>

      <p style={{
        margin: 0,
        fontFamily: "'Poppins', sans-serif",
        fontSize: 14,
        color: '#333',
        lineHeight: '1.4',
        textAlign: 'left',
        maxWidth: '90%'
      }}>
        Choose a friendly, professional photo so potential clients can can see you. A welcoming image helps build connection from the start.
      </p>
      <div
        style={{
          border: '1px solid #eee',
          borderRadius: 8,
          minHeight: 160,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#fafbfc',
          cursor: 'pointer',
        }}
        onClick={() => fileInputRef.current.click()}
      >
        {data.profilePhoto ? (
          <img
            src={URL.createObjectURL(data.profilePhoto)}
            alt="Profile Preview"
            style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
          />
        ) : data.profilePhotoUrl ? (
          <img
            src={data.profilePhotoUrl}
            alt="Existing Profile"
            style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
          />
        ) : (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 40 }}>
              <img alt="upload Logo" src={uploadIcon} />
            </div>
            <div style={{ color: "#1abc9c", fontWeight: 500 }}>Upload</div>
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
        <button
          type="button"
          onClick={handleNextClick}
          style={{
            marginTop: 32,
            padding: 0,
            background: 'none',
            border: 'none',
            cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            opacity: loading ? 0.6 : 1,
          }}
          disabled={loading}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            background: '#07405A',
            borderRadius: 8,
            boxShadow: '0px 4px 12px 0px rgba(7, 64, 90, 0.10)',
            padding: '0 24px 0 24px',
            height: 48,
            minWidth: 160,
            gap: 10,
            position: 'relative',
          }}>
            <span style={{
              color: '#fff',
              fontWeight: 700,
              fontSize: 16,
              fontFamily: 'inherit',
              marginRight: 24,
            }}>
              Next
            </span>
            <span style={{ position: 'absolute', right: 10 }}>
              <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18.3673" cy="18.3673" r="17.8673" fill="white" fillOpacity="0.1" stroke="white" />
                <path d="M17.993 11.995L24.7402 18.7421L17.993 24.7396" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path opacity="0.5" d="M13 13.7257L18.2478 18.8853L13 23.4716" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </div>
        </button>
      </div>
      {error && <div style={{ color: 'red', fontSize: 14 }}>{error}</div>}
    </div>
  );
};

export default StepProfilePhoto; 
